module.exports = "query Categories {\n  categories {\n    id\n    name\n    status\n    slug\n    is_menu\n    menu_order\n    is_home\n    home_order\n    menu_icon\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Categories.graphql
// module id = 1866
// module chunks = 1612